import axios2 from '../api/axios';
export const manufacturingServices = {
    createmanufacturing,
    editmanufacturing,
    getmanufacturing,
    deletemanufacturing,
    getproductname,
    // getDepartment,
    // createdesignation,
    // getDesignations    
    
}

function createmanufacturing(objdata){
    return axios2.post(`/manufacturingAdd`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function editmanufacturing(objdata){
    return axios2.post(`/editmanufacturing`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

 function deletemanufacturing(id){
     return axios2.post(`/deletemanufacturing`,id,((response)=>{
          return response;   
     })).catch((error)=>{
          console.log(error); 
     })  
 }
 
function getmanufacturing(page,pageSize){
    return axios2.get(`/getmanufacturing?page=${page}&limit=${pageSize}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getproductname(id=0){
    return axios2.get(`/getproductname/${id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}


